/**
 * Acknowledgement checkboxes from the signer's meta. Required items gate
 * the submit button; accepted ids go out as `accepted_acknowledgements`.
 */
export function SignAcknowledgements({ items, accepted, onToggle }) {
  if (!items?.length) return null;
  return (
    <section className="bg-white border border-[#D5D8DD] rounded-sm" data-testid="sign-acks">
      <header className="px-4 sm:px-6 py-3 border-b border-[#E6E8EC]">
        <div className="text-[10px] font-semibold uppercase tracking-wider text-[#5C6370]">Step 2</div>
        <h2 className="text-base font-bold text-[#111417]">Acknowledgements</h2>
      </header>
      <div className="divide-y divide-[#E6E8EC]">
        {items.map((it) => (
          <label key={it.id} className="flex items-start gap-3 px-4 sm:px-6 py-3 cursor-pointer hover:bg-[#F4F5F7] transition-colors">
            <input
              type="checkbox"
              checked={!!accepted[it.id]}
              onChange={(e) => onToggle(it.id, e.target.checked)}
              data-testid={`sig-ack-${it.id}`}
              className="mt-0.5 w-5 h-5 shrink-0 accent-[#4575A8]"
            />
            <span className="text-sm text-[#111417] leading-relaxed">
              {it.label}
              {it.required && <span className="ml-1 text-[#B4463A]" aria-label="required">*</span>}
              {it.description && <span className="block text-xs text-[#5C6370] mt-0.5">{it.description}</span>}
            </span>
          </label>
        ))}
      </div>
    </section>
  );
}

export const missingRequired = (items, accepted) => (items || []).filter((it) => it.required && !accepted[it.id]);

export default SignAcknowledgements;
